var modules_efc4e723 = {"container":"_13t3duf","container_video":"_1wdh75b","placeholder":"_1s4oos4","placeholder_side":"_jufise","placeholder_tgbm7":"_1e6g1la","placeholder_top":"_vyxjnf","placeholder_video":"_1aakh8s"};
import "../../../assets/DlgTq1Kv.css";

export { modules_efc4e723 as default };
//# sourceMappingURL=styles.module.scss.js.map
